var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuIcBookmark = function SvgMenuIcBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.89 0h24v24h-24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#67AEFF",
    stroke: "#131317",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M5.467 4.722a2 2 0 0 1 2-2h10.845a2 2 0 0 1 2 2v14.752a1 1 0 0 1-1.53.848l-5.893-3.683-5.892 3.683a1 1 0 0 1-1.53-.848z"
  })));
};
export default SvgMenuIcBookmark;